
<div class="node-net-container">
	<div :id="id" ref="nodenet" class="node-net" />
	<slot />
	<div :open="overlay" class="node-net-overlay" @click.stop="togglePopOver($event)" />
</div>
